import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';

const CONTACT_ITEMS = [
  { abbr: 'PH', label: 'Phone', value: '+91 8374422411', href: 'tel:+918374422411', bg: 'rgba(200,23,26,0.18)', color: '#fca5a5' },
  { abbr: 'WA', label: 'WhatsApp', value: '+91 8374422411', href: 'https://wa.me/918374422411', bg: 'rgba(22,163,74,0.18)', color: '#86efac' },
  { abbr: '@', label: 'Email', value: 'support@vijayavarshi.com', href: 'mailto:support@vijayavarshi.com', bg: 'rgba(124,58,237,0.18)', color: '#c4b5fd' },
  { abbr: 'HR', label: 'Hours', value: 'Mon – Sun, 6:00 AM – 8:00 PM', href: null, bg: 'rgba(13,148,136,0.18)', color: '#5eead4' },
  { abbr: 'AD', label: 'Factory Address', org: 'TELANGANA STATE CO-OPERATIVE OIL SEEDS GROWER FEDERATION LTD', street: '6-3-192/1/a/8, NH 44, Adarsh Nagar, Shivarampally Jagir, Telangana – 500052', href: null, bg: 'rgba(180,83,9,0.18)', color: '#fdba74' },
];

const SUBJECTS = [
  { value: 'order', label: 'Place an Order' },
  { value: 'pricing', label: 'Pricing Enquiry' },
  { value: 'bulk', label: 'Bulk / Commercial Order' },
  { value: 'complaint', label: 'Complaint' },
  { value: 'other', label: 'Other' },
];

const inputStyle = {
  width: '100%',
  padding: '0.75rem 1rem',
  borderRadius: '10px',
  border: '1.5px solid #e2e8f0',
  fontSize: '0.9rem',
  color: '#0c1a2e',
  background: '#f8fafc',
  outline: 'none',
  boxSizing: 'border-box',
  fontFamily: 'inherit',
  transition: 'border-color 0.15s, background 0.15s',
};

export default function ContactPage() {
  const [form, setForm] = useState({ name: '', phone: '', email: '', subject: 'order', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [focused, setFocused] = useState(null);

  const set = key => e => setForm(f => ({ ...f, [key]: e.target.value }));
  const focus = key => () => setFocused(key);
  const blur = () => setFocused(null);
  const fieldStyle = key => ({ ...inputStyle, borderColor: focused === key ? '#C8171A' : '#e2e8f0', background: focused === key ? '#fff' : '#f8fafc' });

  const handleSubmit = e => {
    e.preventDefault();
    if (!form.name || !form.phone) { toast.error('Name and phone are required'); return; }
    setSubmitted(true);
    toast.success('Message sent! We will contact you shortly.');
  };

  return (
    <div style={{ background: '#f8fafc' }}>

      {/* Slim Hero */}
      <section style={{ background: 'linear-gradient(160deg, #FFF8F8 0%, #FDE8E8 100%)', padding: '2rem 1.5rem', borderBottom: '1px solid #fecaca' }}>
        <div className="page-container">
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.75rem', fontSize: '0.82rem' }}>
            <Link to="/" style={{ color: '#94a3b8', textDecoration: 'none' }}>Home</Link>
            <span style={{ color: '#cbd5e1' }}>/</span>
            <span style={{ color: '#C8171A', fontWeight: 600 }}>Contact</span>
          </div>
          <h1 style={{ fontSize: 'clamp(1.5rem, 3vw, 2.25rem)', fontWeight: 800, color: '#0c1a2e', margin: 0, lineHeight: 1.2 }}>
            Get in Touch
          </h1>
          <p style={{ color: '#64748b', marginTop: '0.5rem', fontSize: '0.95rem' }}>
            Order water, ask a question, or discuss a bulk deal — we respond within the hour.
          </p>
        </div>
      </section>

      {/* Main Two-Column */}
      <section style={{ padding: '3rem 1.5rem' }}>
        <div className="page-container">
          <div className="contact-layout">

            {/* Left — light contact panel */}
            <div style={{ background: 'linear-gradient(160deg, #ffffff 0%, #FFF0F0 60%, #FFE4E4 100%)', borderRadius: '20px', padding: '2.5rem 2rem', border: '1px solid #fecaca', boxShadow: '0 4px 24px rgba(200,23,26,0.08)' }}>
              <h2 style={{ fontSize: '1.35rem', fontWeight: 800, color: '#0c1a2e', marginBottom: '0.4rem' }}>Contact Information</h2>
              <p style={{ fontSize: '0.875rem', color: '#64748b', marginBottom: '2rem', lineHeight: 1.6 }}>
                We are open 7 days a week. Reach us through any of the channels below.
              </p>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem', marginBottom: '2.5rem' }}>
                {CONTACT_ITEMS.map(item => (
                  <div key={item.label} style={{ display: 'flex', alignItems: item.org ? 'flex-start' : 'center', gap: '1rem' }}>
                    <div style={{ width: 42, height: 42, borderRadius: '10px', background: item.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.72rem', fontWeight: 800, color: item.color, letterSpacing: '0.02em', flexShrink: 0, marginTop: item.org ? '0.15rem' : 0 }}>
                      {item.abbr}
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '0.7rem', fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: '0.25rem' }}>{item.label}</div>
                      {item.org ? (
                        <div style={{ background: 'rgba(180,83,9,0.06)', borderRadius: '8px', padding: '0.6rem 0.75rem', border: '1px solid rgba(180,83,9,0.12)' }}>
                          <div style={{ fontSize: '0.78rem', fontWeight: 700, color: '#92400e', lineHeight: 1.4, marginBottom: '0.35rem' }}>{item.org}</div>
                          <div style={{ fontSize: '0.82rem', color: '#374151', fontWeight: 500, lineHeight: 1.6 }}>{item.street}</div>
                        </div>
                      ) : item.href ? (
                        <a href={item.href} style={{ color: '#0c1a2e', fontWeight: 600, fontSize: '0.875rem', textDecoration: 'none' }}>{item.value}</a>
                      ) : (
                        <span style={{ color: '#374151', fontSize: '0.875rem', fontWeight: 500 }}>{item.value}</span>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              {/* Live status */}
              <div style={{ background: '#f0fdf4', borderRadius: '12px', padding: '1rem 1.25rem', marginBottom: '1.75rem', border: '1px solid #bbf7d0' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.35rem' }}>
                  <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#22c55e', display: 'inline-block' }} />
                  <span style={{ fontSize: '0.8rem', color: '#16a34a', fontWeight: 700 }}>We're Open Now</span>
                </div>
                <p style={{ fontSize: '0.8rem', color: '#64748b', margin: 0, lineHeight: 1.5 }}>
                  Order by 10 AM for same-day delivery across Hyderabad.
                </p>
              </div>

              {/* Action buttons */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                <a
                  href="tel:8374422411"
                  style={{ display: 'block', textAlign: 'center', background: '#C8171A', color: 'white', padding: '0.8rem', borderRadius: '10px', fontWeight: 700, fontSize: '0.9rem', textDecoration: 'none', boxShadow: '0 4px 14px rgba(200,23,26,0.3)' }}
                >
                  Call Now — +91 8374422411
                </a>
                <a
                  href="https://wa.me/918374422411"
                  target="_blank"
                  rel="noreferrer"
                  style={{ display: 'block', textAlign: 'center', background: '#16a34a', color: 'white', padding: '0.8rem', borderRadius: '10px', fontWeight: 700, fontSize: '0.9rem', textDecoration: 'none' }}
                >
                  Chat on WhatsApp
                </a>
              </div>
            </div>

            {/* Right — form */}
            <div style={{ background: 'white', borderRadius: '20px', padding: '2.5rem 2.5rem', boxShadow: '0 4px 24px rgba(0,0,0,0.06)', border: '1px solid #f1f5f9' }}>
              {submitted ? (
                <div style={{ textAlign: 'center', padding: '3rem 1rem' }}>
                  <div style={{ width: 72, height: 72, borderRadius: '50%', background: '#dcfce7', border: '3px solid #86efac', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1.5rem', fontSize: '2rem', color: '#16a34a', fontWeight: 900 }}>
                    ✓
                  </div>
                  <h3 style={{ fontWeight: 800, color: '#0c1a2e', fontSize: '1.35rem', marginBottom: '0.5rem' }}>Message Received!</h3>
                  <p style={{ color: '#64748b', marginBottom: '2rem', lineHeight: 1.7 }}>
                    Thank you for reaching out. We will call you back within 1 hour during business hours.
                  </p>
                  <button
                    onClick={() => setSubmitted(false)}
                    style={{ background: '#f1f5f9', color: '#0c1a2e', border: 'none', borderRadius: '10px', padding: '0.75rem 2rem', fontWeight: 700, fontSize: '0.9rem', cursor: 'pointer', fontFamily: 'inherit' }}
                  >
                    Send Another Message
                  </button>
                </div>
              ) : (
                <>
                  <h2 style={{ fontSize: '1.35rem', fontWeight: 800, color: '#0c1a2e', marginBottom: '0.35rem' }}>Send an Enquiry</h2>
                  <p style={{ color: '#94a3b8', fontSize: '0.875rem', marginBottom: '2rem' }}>Fill in the form and we'll get back to you promptly.</p>

                  <form onSubmit={handleSubmit}>
                    <div className="contact-form-row">
                      <div>
                        <label style={{ display: 'block', fontSize: '0.78rem', fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '0.45rem' }}>Full Name *</label>
                        <input
                          style={fieldStyle('name')}
                          placeholder="Your full name"
                          value={form.name}
                          onChange={set('name')}
                          onFocus={focus('name')}
                          onBlur={blur}
                          required
                        />
                      </div>
                      <div>
                        <label style={{ display: 'block', fontSize: '0.78rem', fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '0.45rem' }}>Phone Number *</label>
                        <input
                          style={fieldStyle('phone')}
                          placeholder="10-digit mobile number"
                          value={form.phone}
                          onChange={set('phone')}
                          onFocus={focus('phone')}
                          onBlur={blur}
                          required
                        />
                      </div>
                    </div>

                    <div style={{ marginBottom: '1rem' }}>
                      <label style={{ display: 'block', fontSize: '0.78rem', fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '0.45rem' }}>Email Address</label>
                      <input
                        type="email"
                        style={fieldStyle('email')}
                        placeholder="your@email.com"
                        value={form.email}
                        onChange={set('email')}
                        onFocus={focus('email')}
                        onBlur={blur}
                      />
                    </div>

                    <div style={{ marginBottom: '1rem' }}>
                      <label style={{ display: 'block', fontSize: '0.78rem', fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '0.45rem' }}>Subject</label>
                      <select
                        style={{ ...fieldStyle('subject'), appearance: 'none', cursor: 'pointer' }}
                        value={form.subject}
                        onChange={set('subject')}
                        onFocus={focus('subject')}
                        onBlur={blur}
                      >
                        {SUBJECTS.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
                      </select>
                    </div>

                    <div style={{ marginBottom: '1.75rem' }}>
                      <label style={{ display: 'block', fontSize: '0.78rem', fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '0.45rem' }}>Message</label>
                      <textarea
                        style={{ ...fieldStyle('message'), resize: 'vertical', minHeight: '120px' }}
                        placeholder="Tell us what you need — product, quantity, delivery area..."
                        value={form.message}
                        onChange={set('message')}
                        onFocus={focus('message')}
                        onBlur={blur}
                        rows={4}
                      />
                    </div>

                    <button
                      type="submit"
                      style={{ width: '100%', background: '#C8171A', color: 'white', border: 'none', borderRadius: '12px', padding: '0.95rem', fontSize: '1rem', fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit', boxShadow: '0 4px 14px rgba(200,23,26,0.3)', transition: 'opacity 0.15s' }}
                      onMouseEnter={e => e.currentTarget.style.opacity = '0.9'}
                      onMouseLeave={e => e.currentTarget.style.opacity = '1'}
                    >
                      Send Message &rarr;
                    </button>
                  </form>
                </>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Info strip */}
      <section style={{ background: 'white', borderTop: '1px solid #f1f5f9', padding: '2rem 1.5rem' }}>
        <div className="page-container">
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1.5rem', textAlign: 'center' }}>
            {[
              { label: 'Response Time', value: 'Within 1 Hour', note: 'During business hours' },
              { label: 'Location', value: 'Shivarampally Jagir, Hyderabad', note: 'NH 44, Adarsh Nagar, Telangana – 500052' },
              { label: 'Available', value: 'Mon – Sun', note: '6:00 AM to 8:00 PM' },
              { label: 'Min. Order', value: '1 Jar / Bottle', note: 'No minimum for home orders' },
            ].map(item => (
              <div key={item.label} style={{ padding: '1.25rem', borderRadius: '12px', background: '#f8fafc', border: '1px solid #f1f5f9' }}>
                <div style={{ fontSize: '0.7rem', fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: '0.4rem' }}>{item.label}</div>
                <div style={{ fontSize: '1.05rem', fontWeight: 800, color: '#0c1a2e', marginBottom: '0.25rem' }}>{item.value}</div>
                <div style={{ fontSize: '0.78rem', color: '#94a3b8' }}>{item.note}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
